// src/components/finance/steps/OTPStep.jsx
import React, { useState, useEffect } from 'react';
import '../../../styles/LoanSteps.css';

const OTPStep = ({ mobile, onNext, onPrevious, onResend, loading }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = React.useRef([]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleResend = async () => {
    setCanResend(false);
    setTimer(60);
    setOtp(['', '', '', '', '', '']);
    await onResend();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpCode = otp.join('');
    if (otpCode.length === 6) {
      onNext({ otp: otpCode });
    }
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <h3>OTP will be sent to:</h3>
        <p className="mobile-number">{mobile}</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form">
        <div className="otp-input-group">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={el => inputRefs.current[index] = el}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="otp-input"
              autoFocus={index === 0}
            />
          ))}
        </div>

        <div className="resend-section">
          {canResend ? (
            <button type="button" onClick={handleResend} className="resend-button">
              Resend OTP
            </button>
          ) : (
            <p className="timer-text">Resend OTP in {timer} seconds</p>
          )}
        </div>

        <div className="button-group">
          <button type="button" onClick={onPrevious} className="previous-button">
            Previous
          </button>
          <button 
            type="submit" 
            className="next-button" 
            disabled={loading || otp.join('').length !== 6}
          >
            {loading ? 'Verifying...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default OTPStep;